import { render } from "./user-section.vue?vue&type=template&id=8801701a&ts=true"
import script from "./user-section.vue?vue&type=script&lang=ts"
export * from "./user-section.vue?vue&type=script&lang=ts"

import "./user-section.vue?vue&type=style&index=0&id=8801701a&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__